import type { ReactNode } from 'react';
import type { MetricProps } from './styled';
import {
  MetricWrapper,
  Title,
  Metric,
  TitleColumn,
  MetricColumn,
} from './styled';

interface KeyMetricProps extends MetricProps {
  title?: ReactNode;
  metric: ReactNode;
  testId: string;
}

const KeyMetric = ({ title, metric, type, testId }: KeyMetricProps) => {
  return (
    <MetricWrapper type={type}>
      {title && (
        <TitleColumn type={type}>
          <Title data-cy-id={`key-metric-title-${testId}`} type={type}>
            {title}
          </Title>
        </TitleColumn>
      )}
      <MetricColumn type={type}>
        <Metric as="span" data-cy-id={`key-metric-value-${testId}`} type={type}>
          {metric}
        </Metric>
      </MetricColumn>
    </MetricWrapper>
  );
};

export default KeyMetric;
